<template>
  <!-- 工单管理-工程报装全部流程详情 -->
  <j-modal
    :title="title"
    :width="1000"
    :visible="visible"
    :confirmLoading="confirmLoading"
    :maskClosable="false"
    :body-style="{ maxHeight: '600px', overflow: 'hidden', overflowY: 'scroll' }"
    @cancel="handleCancel"
    :okText="$t('确定')"
    :cancelText="$t('关闭')"
    :okButtonProps="{ class: { 'jee-hidden': disableSubmit } }"
  >
    <a-spin :spinning="confirmLoading">
      <div class="form-contain">
        <a-divider orientation="left">{{ $t('工单信息') }}</a-divider>
        <detail-list :col="2">
          <detail-list-item :term="$t('工单编号')">{{ ticketsData.ticketsNum }}</detail-list-item>
          <detail-list-item :term="$t('工单类型')">
            {{
              {
                1: $t('个人报装'),
                5: $t('用水'),
                6: $t('企业报装'),
              }[ticketsData.ticketsType] || ''
            }}
          </detail-list-item>
        </detail-list>
        <detail-list :col="2">
          <detail-list-item :term="$t('工单联系人')">{{ ticketsData.ticketsContact }}</detail-list-item>
          <detail-list-item :term="$t('联系电话')">{{ ticketsData.ticketsContactPhone }}</detail-list-item>
        </detail-list>
        <detail-list :col="2">
          <detail-list-item :term="$t('紧急程度')">{{ setJJ(ticketsData.ticketsEmergency) }}</detail-list-item>
          <!-- <detail-list-item term="地理信息">{{ticketsData.ticketsLocation}}</detail-list-item> -->
        </detail-list>
        <!-- <detail-list :col="2">
                    <detail-list-item term="截止时间">{{ticketsData.ticketsDeadline}}</detail-list-item>
                </detail-list> -->

        <a-collapse v-model="collKey" :accordion="true">
          <a-collapse-panel key="1" :header="$t('报装申请信息')" :forceRender="false">
            <!-- 个人新装 -->
            <detail-list v-if="ticketsData.ticketsType == 1">
              <a-divider orientation="left">{{ $t('安装信息') }}</a-divider>

              <detail-list :col="2">
                <detail-list-item :term="$t('区域信息')">{{ installationDetail.areaName }}</detail-list-item>
                <detail-list-item :term="$t('用水地址')">{{ installationDetail.waterAddress }}</detail-list-item>
              </detail-list>
              <detail-list :col="2">
                <detail-list-item :itemCol="1" :term="$t('申请用水原因及要求')">{{
                  installationDetail.reasonapplication
                }}</detail-list-item>
              </detail-list>

              <a-divider orientation="left">{{ $t('产权人信息') }}</a-divider>

              <detail-list :col="2">
                <detail-list-item :term="$t('产权人姓名')">{{ installationDetail.clientName }}</detail-list-item>
                <detail-list-item :term="$t('身份证号')">{{ installationDetail.identificationNumber }}</detail-list-item>
              </detail-list>
              <detail-list :col="2">
                <detail-list-item :term="$t('用户类别')">{{
                  userTypeList.find(u => u.id == installationDetail.clientType) &&
                  userTypeList.find(u => u.id == installationDetail.clientType).utName
                }}</detail-list-item>
              </detail-list>

              <detail-list :col="2">
                <detail-list-item :term="$t('用户身份证正反面')" style="display: flex">
                  <j-image-upload
                    class="avatar-uploader"
                    :text="$t('上传')"
                    :isMultiple="true"
                    v-model="installationDetail.userIdCards"
                    :disabled="true"
                  ></j-image-upload>
                </detail-list-item>
                <detail-list-item :term="$t('房产证')" style="display: flex">
                  <j-image-upload
                    class="avatar-uploader"
                    :text="$t('上传')"
                    :isMultiple="true"
                    v-model="installationDetail.userTitleDeed"
                    :disabled="true"
                  ></j-image-upload>
                </detail-list-item>
              </detail-list>

              <a-divider orientation="left">{{ $t('联系人信息') }}</a-divider>

              <detail-list :col="2">
                <detail-list-item :term="$t('是否委托')">{{
                  installationDetail.whetherEntrust == 1 ? $t('是') : $t('否')
                }}</detail-list-item>
                <detail-list-item :term="$t('联系人姓名')">{{ installationDetail.reportUserName }}</detail-list-item>
                <detail-list-item :term="$t('联系人电话')">{{ installationDetail.phone }}</detail-list-item>
              </detail-list>
              <detail-list :col="2" v-if="installationDetail.whetherEntrust == 0">
                <detail-list-item :term="$t('营业执照')" style="display: flex">
                  <j-image-upload
                    class="avatar-uploader"
                    :text="$t('上传')"
                    :isMultiple="true"
                    v-model="installationDetail.businessLicense"
                    :disabled="true"
                  ></j-image-upload>
                </detail-list-item>
              </detail-list>
              <detail-list :col="2" v-if="installationDetail.whetherEntrust == 1">
                <detail-list-item :term="$t('被委托人身份证正反面')" style="display: flex">
                  <j-image-upload
                    class="avatar-uploader"
                    :text="$t('上传')"
                    :isMultiple="true"
                    v-model="installationDetail.reportUserIdCards"
                    :disabled="true"
                  ></j-image-upload>
                </detail-list-item>
                <detail-list-item :term="$t('委托书')" style="display: flex">
                  <j-image-upload
                    class="avatar-uploader"
                    :text="$t('上传')"
                    :isMultiple="true"
                    v-model="installationDetail.letterOfAuthorization"
                    :disabled="true"
                  ></j-image-upload>
                </detail-list-item>
              </detail-list>
            </detail-list>

            <!-- 企业新装 -->
            <detail-list v-if="ticketsData.ticketsType == 5 || ticketsData.ticketsType == 6">
              <a-divider orientation="left">{{ $t('安装信息') }}</a-divider>
              <detail-list :col="2">
                <detail-list-item :term="$t('区域信息')">{{ installationDetail.areaName }}</detail-list-item>
                <detail-list-item :term="$t('用水地址')">{{ installationDetail.waterAddress }}</detail-list-item>
              </detail-list>
              <detail-list :col="2">
                <detail-list-item :itemCol="1" :term="$t('申请用水原因及要求')">{{
                  installationDetail.reasonapplication
                }}</detail-list-item>
              </detail-list>

              <a-divider orientation="left">{{ $t('申请主体单位信息') }}</a-divider>
              <detail-list :col="2">
                <detail-list-item :term="$t('单位名称')">{{ installationDetail.companyName }}</detail-list-item>
                <detail-list-item :term="$t('单位地址')">{{ installationDetail.organizationAddress }}</detail-list-item>
              </detail-list>
              <detail-list :col="2">
                <detail-list-item :term="$t('统一社会信用代码')">{{ installationDetail.socialCreditCode }}</detail-list-item>
                <detail-list-item :term="$t('用户类别')">{{
                  userTypeList.find(u => u.id == installationDetail.clientType) &&
                  userTypeList.find(u => u.id == installationDetail.clientType).utName
                }}</detail-list-item>
              </detail-list>

              <detail-list :col="2">
                <detail-list-item :term="$t('营业执照')" style="display: flex">
                  <j-image-upload
                    class="avatar-uploader"
                    :text="$t('上传')"
                    :isMultiple="true"
                    v-model="installationDetail.businessLicense"
                    :disabled="true"
                  ></j-image-upload>
                </detail-list-item>
              </detail-list>

              <a-divider orientation="left">{{ $t('法人信息') }}</a-divider>

              <detail-list :col="2">
                <detail-list-item :term="$t('法人姓名')">{{ installationDetail.corporationName }}</detail-list-item>
                <detail-list-item :term="$t('法人身份证号码')">{{ installationDetail.identificationNumber }}</detail-list-item>
              </detail-list>

              <detail-list :col="2">
                <detail-list-item :term="$t('法人身份证正反面')" style="display: flex">
                  <j-image-upload
                    class="avatar-uploader"
                    :text="$t('上传')"
                    :isMultiple="true"
                    v-model="installationDetail.userIdCards"
                    :disabled="true"
                  ></j-image-upload>
                </detail-list-item>
                <detail-list-item :term="$t('房产证')" style="display: flex">
                  <j-image-upload
                    class="avatar-uploader"
                    :text="$t('上传')"
                    :isMultiple="true"
                    v-model="installationDetail.userTitleDeed"
                    :disabled="true"
                  ></j-image-upload>
                </detail-list-item>
              </detail-list>

              <a-divider orientation="left">{{ $t('联系人信息') }}</a-divider>
              <detail-list :col="2">
                <detail-list-item :term="$t('是否委托')">{{
                  installationDetail.whetherEntrust == 1 ? $t('是') : $t('否')
                }}</detail-list-item>
              </detail-list>
              <detail-list :col="2">
                <detail-list-item :term="$t('联系人姓名')">{{ installationDetail.clientName }}</detail-list-item>
                <detail-list-item :term="$t('联系人电话')">{{ installationDetail.phone }}</detail-list-item>
              </detail-list>
              <detail-list :col="2" v-if="installationDetail.whetherEntrust == 1">
                <detail-list-item :term="$t('被委托人身份证正反面')" style="display: flex">
                  <j-image-upload
                    class="avatar-uploader"
                    :text="$t('上传')"
                    :isMultiple="true"
                    v-model="installationDetail.reportUserIdCards"
                    :disabled="true"
                  ></j-image-upload>
                </detail-list-item>
                <detail-list-item :term="$t('委托书')" style="display: flex">
                  <j-image-upload
                    class="avatar-uploader"
                    :text="$t('上传')"
                    :isMultiple="true"
                    v-model="installationDetail.letterOfAuthorization"
                    :disabled="true"
                  ></j-image-upload>
                </detail-list-item>
              </detail-list>

              <a-divider orientation="left">{{ $t('申请公函') }}</a-divider>
              <detail-list :col="2">
                <detail-list-item :term="$t('单位加盖公章申请书')" style="display: flex">
                  <j-image-upload
                    class="avatar-uploader"
                    :text="$t('上传')"
                    :isMultiple="true"
                    v-model="installationDetail.companyApplicationForm"
                    :disabled="true"
                  ></j-image-upload>
                </detail-list-item>
              </detail-list>
            </detail-list>
          </a-collapse-panel>
          <a-collapse-panel
            key="3"
            :header="$t('勘测设计信息')"
            :forceRender="false"
            :disabled="!(ticketsData.ticketsState >= 2)"
          >
            <detail-list>
              <detail-list-item :term="$t('勘察相约时间')">{{ investigationDetail.investigationMeetTime }}</detail-list-item>
              <detail-list-item :term="$t('勘察实际时间')">{{ investigationDetail.investigationActualTime }}</detail-list-item>
              <detail-list-item :term="$t('安全状况')">{{
                securityPostureList[investigationDetail.securityPosture]
              }}</detail-list-item>
            </detail-list>
            <detail-list>
              <detail-list-item :term="$t('施工环境')">{{ investigationDetail.constructionEnvironment }}</detail-list-item>
              <detail-list-item :term="$t('日供水量(m³)')">{{ investigationDetail.dailyWaterSupply }}</detail-list-item>
              <!-- <detail-list-item term="是否个人施工" v-if="[1, 6].includes(ticketsData.ticketsType)">{{
                installationDetail.ifPersonalDeal == 1 ? '是' : '否'
              }}</detail-list-item> -->
            </detail-list>
            <detail-list>
              <detail-list-item :term="$t('备注')">{{ investigationDetail.remark }}</detail-list-item>
            </detail-list>
            <a-col :span="24">
              <a-form-model-item :label="$t('附件')">
                <JUpload v-model="fileList2" :buttonVisible="false" />
              </a-form-model-item>
            </a-col>
            <a-col :span="24">
              <a-form-model-item :label="$t('图片')">
                <j-image-upload
                  class="avatar-uploader"
                  :text="$t('上传')"
                  :isMultiple="true"
                  v-model="investigationDetail.picture"
                  :disabled="true"
                ></j-image-upload>
              </a-form-model-item>
            </a-col>
          </a-collapse-panel>
          <a-collapse-panel
            key="4"
            :header="$t('设计信息')"
            :forceRender="false"
            :disabled="
              !(
                ticketsData.ticketsState >= 3
              )
            "
          >
            <detail-list>
              <!-- <detail-list-item term="工程预算(元)">{{ engineeringDrawing.projectBudget }}</detail-list-item> -->
              <detail-list-item :term="$t('是否排水')">{{ engineeringDrawing.isDrain == 1 ? $t('是') : $t('否') }}</detail-list-item>
              <detail-list-item :term="$t('报装口径')">{{ engineeringDrawing.caliberReport }}</detail-list-item>
              <detail-list-item :term="$t('管线长度及规格(米)')">{{
                engineeringDrawing.pipelineLengthSpecifications
              }}</detail-list-item>
              <detail-list-item :term="$t('备注信息')">{{ engineeringDrawing.remark }}</detail-list-item>
            </detail-list>
            <a-col :span="8">
              <a-form-model-item :label="$t('附件')">
                <JUpload v-model="fileList3" :buttonVisible="false" />
              </a-form-model-item>
            </a-col>
          </a-collapse-panel>
          <a-collapse-panel
            key="5"
            :header="$t('预算信息')"
            :forceRender="false"
            :disabled="
              !(
                ticketsData.ticketsState >= 4
              )
            "
          >
            <detail-list>
              <detail-list-item :term="$t('工程预算(元)')">{{ engineeringDrawing.projectBudget }}</detail-list-item>
            </detail-list>
          </a-collapse-panel>
          <a-collapse-panel
            key="6"
            :header="$t('收费信息')"
            :forceRender="false"
            :disabled="
              !(
                ticketsData.ticketsState >= 5
              )
            "
          >
            <detail-list>
              <detail-list-item :term="$t('合同名称')">{{ contractDetail.contractName }}</detail-list-item>
              <detail-list-item :term="$t('合同金额(元)')">{{ contractDetail.contractAmount }}</detail-list-item>
              <detail-list-item :term="$t('甲方')">{{ contractDetail.partyA }}</detail-list-item>
              <detail-list-item :term="$t('乙方')">{{ contractDetail.partyB }}</detail-list-item>
              <detail-list-item :term="$t('备注说明')">{{ contractDetail.remark }}</detail-list-item>
              <detail-list-item :term="$t('费用已收取')">{{ contractDetail.isCharge == 1 ? $t('是') : $t('否') }}</detail-list-item>
              <detail-list-item
                :term="$t('预存金额')"
                v-if="ticketsData.ticketsType == 5 && installationDetail.whetherUseWaterTemporarily == 1"
                >{{ contractDetail.preDepositedAmount }}</detail-list-item
              >
            </detail-list>
            <a-col :span="8">
              <a-form-model-item :label="$t('合同附件')">
                <JUpload v-model="fileList4" :buttonVisible="false" />
              </a-form-model-item>
            </a-col>
            <a-col :span="8">
              <a-form-model-item :label="$t('费用附件')">
                <JUpload v-model="fileList5" :buttonVisible="false" />
              </a-form-model-item>
            </a-col>
          </a-collapse-panel>
          <a-collapse-panel
            key="7"
            :header="$t('施工信息')"
            :forceRender="false"
            :disabled="
              !(
                ticketsData.ticketsState >= 6
              )
            "
          >
            <detail-list>
              <detail-list-item :term="$t('是否存在设计变更')">{{
                constructionDetail.isDesignChanges == 1 ? $t('是') : $t('否')
              }}</detail-list-item>
              <detail-list-item :term="$t('施工备注')">{{ constructionDetail.constructionRemark }}</detail-list-item>
              <detail-list-item :term="$t('备注')">{{ constructionDetail.remark }}</detail-list-item>
            </detail-list>
            <a-col :span="8">
              <a-form-model-item :label="$t('施工附件')">
                <JUpload v-model="fileList6" :buttonVisible="false" />
              </a-form-model-item>
            </a-col>
            <a-col :span="8">
              <a-form-model-item :label="$t('验收附件')">
                <JUpload v-model="fileList7" :buttonVisible="false" />
              </a-form-model-item>
            </a-col>
          </a-collapse-panel>
          <!-- 是否个人施工 个人施工才有这两步 -->
          <!-- <a-collapse-panel
            key="8"
            header="施工申请"
            :forceRender="false"
            v-if="installationDetail.ifPersonalDeal == 1"
            :disabled="!(ticketsData.ticketsState >= 7)"
          >
            <detail-list :col="1">
              <detail-list-item term="施工申请描述">{{
                personalDealDetail.constructionApplicationDescription
              }}</detail-list-item>
            </detail-list>

            <a-col :span="24">
              <a-form-model-item label="图片">
                <j-image-upload
                  class="avatar-uploader"
                  text="上传"
                  :isMultiple="true"
                  v-model="personalDealDetail.constructionApplicationPicture"
                  :disabled="true"
                ></j-image-upload>
              </a-form-model-item>
            </a-col>
          </a-collapse-panel>
          <a-collapse-panel
            key="9"
            header="核验稽查"
            :forceRender="false"
            v-if="installationDetail.ifPersonalDeal == 1"
            :disabled="!(ticketsData.ticketsState >= 8)"
          >
            <detail-list :col="1">
              <detail-list-item term="核验稽查描述">{{ personalDealDetail.inspectionDescription }}</detail-list-item>
            </detail-list>

            <a-col :span="24">
              <a-form-model-item label="图片">
                <j-image-upload
                  class="avatar-uploader"
                  text="上传"
                  :isMultiple="true"
                  v-model="personalDealDetail.inspectionPicture"
                  :disabled="true"
                ></j-image-upload>
              </a-form-model-item>
            </a-col>
          </a-collapse-panel> -->
          <!-- <a-collapse-panel key="9" header="建档信息" :forceRender="false" :disabled="(disabledKey<10) && disabledKey!=-1">
                        <detail-list>
                            <detail-list-item term="水表厂商">{{model.mtComName}}</detail-list-item>
                            <detail-list-item term="表类型">{{getmtCode(model.mtCode)}}</detail-list-item>
                            <detail-list-item term="册号">{{model.mtVolumeNo}}</detail-list-item>
                            <detail-list-item term="表编号">{{model.meterId}}</detail-list-item>
                            <detail-list-item term="表口径">{{getmtCaliber(model.mtCaliber)}}</detail-list-item>
                            <detail-list-item term="水表用途">{{model.mtUseType == 1?'结算':model.mtUseType == 2?'考核':''}}</detail-list-item>
                            <detail-list-item term="运营商">{{getmtIotType(model.mtIotType)}}</detail-list-item>
                            <detail-list-item term="IMEI">{{model.mtImei}}</detail-list-item>
                            <detail-list-item term="SIM卡号">{{model.mtSim}}</detail-list-item>
                            <detail-list-item term="是否带阀">{{model.mtHasValve == 1?'是':'否'}}</detail-list-item>
                        </detail-list>
                        <a-divider orientation="left">地址信息</a-divider>
                        <detail-list>
                            <detail-list-item term="区域名称">{{model.userAreaName}}</detail-list-item>
                            <detail-list-item term="用户地址">{{model.userAddr}}</detail-list-item>
                            <detail-list-item term="表安装地址">{{model.userMeterAddr}}</detail-list-item>
                            <detail-list-item term="安装经度">{{model.userMeterLng}}</detail-list-item>
                            <detail-list-item term="安装纬度">{{model.userMeterLat}}</detail-list-item>
                        </detail-list>
                        <a-divider orientation="left">用户信息</a-divider>
                        <detail-list>
                            <detail-list-item term="用户编号">{{model.userId}}</detail-list-item>
                            <detail-list-item term="用户姓名">{{model.userName}}</detail-list-item>
                            <detail-list-item term="手机号码">{{model.userPhone}}</detail-list-item>
                            <detail-list-item term="身份证号">{{model.userIdNumber}}</detail-list-item>
                            <detail-list-item term="用户类型">{{getuserTypeCode(model.userTypeCode)}}</detail-list-item>
                        </detail-list>
                    </a-collapse-panel> -->
        </a-collapse>
      </div>
    </a-spin>
  </j-modal>
</template>

<script>
import { httpAction, getAction, postAction } from '@/api/manage'
import { validateDuplicateValue } from '@/utils/util'
import DetailList from '@/components/tools/DetailList'
const DetailListItem = DetailList.Item
import JUpload from '@/components/jeecg/JUpload'
import JImageUpload from '@/components/jeecg/JImageUpload.vue'
import { filterDictTextByMany, filterDictTextByCache } from '@/components/dict/JDictSelectUtil'
export default {
  name: 'workModal',
  components: {
    DetailList,
    DetailListItem,
    JUpload,
    JImageUpload,
  },
  data() {
    return {
      title: '',
      width: 800,
      visible: false,
      disableSubmit: true,
      confirmLoading: false,
      model: {},
      validatorRules: {},
      url: {
        getNodeDetail: '/jeecg-engineering/engineering/installationDetail/getNodeDetail',
        queryById: '/jeecg-engineering/ticket/tickets/queryById',
        meterTypeList: '/jeecg-charge/meter/meterType/list', //表类型请求地址
        userCaliberList: '/jeecg-charge/meter/meterCaliber/list', //表口径请求地址
        meterUserType: '/jeecg-charge/meter/meterUserType/list',
      },
      bool: false,
      disabledKey: 0,
      kcInfo: {},
      sfInfo: {},
      sgInfo: {},
      fileList1: [],
      fileList2: [],
      fileList3: [],
      fileList4: [],
      fileList5: [],
      fileList6: [],
      fileList7: [],
      userTypeList: [], //用户类型
      meterTypeList: [], //表类型
      userCaliberList: [], // 表口径,
      DetailId: '',
      collKey: -1,
      picture: '',
      ticketsData: {},
      installationDetail: {},
      investigationDetail: {},
      engineeringDrawing: {},
      contractDetail: {},
      constructionDetail: {},
      personalDealDetail: {},
    }
  },
  computed: {
    securityPostureList() {
      return ['正常', '恶劣', '极度恶劣'].map(v => this.$t(v))
    },
  },
  created() {
    this.getuserTypeList()
    this.queryUserTypeList()
    this.queryUserCaliberList()
  },
  methods: {
    setJJ(item) {
      return filterDictTextByCache('ticketsEmergency', item)
    },
    getNodeDetail(params) {
      let that = this
      getAction(this.url.queryById, { id: params.id }).then(res => {
        if (res.success) {
          that.ticketsData = { ...res.result }
          // 报装 信息
          that.installationDetail = { ...res.result.installationDetail }
          //   勘察信息
          that.investigationDetail = { ...res.result.installationDetail.investigationDetail }
          // 预算信息
          that.engineeringDrawing = { ...res.result.installationDetail.engineeringDrawing }
          // 合同信息
          that.contractDetail = { ...res.result.installationDetail.contractDetail }
          // 施工信息
          that.constructionDetail = { ...res.result.installationDetail.constructionDetail }
          //
          that.personalDealDetail = { ...res.result.installationDetail.personalDealDetail }

          that.fileList1 = that.installationDetail.annex && [that.installationDetail.annex]
          that.fileList2 = that.investigationDetail.annex && [that.investigationDetail.annex]
          that.fileList3 = that.engineeringDrawing.annex && [that.engineeringDrawing.annex]
          that.fileList4 = that.contractDetail.contractAnnex && [that.contractDetail.contractAnnex]
          that.fileList5 = that.contractDetail.expensesAnnex && [that.contractDetail.expensesAnnex]
          that.fileList6 = that.constructionDetail.constructionAnnex && [that.constructionDetail.constructionAnnex]
          that.fileList7 = that.constructionDetail.acceptanceAnnex && [that.constructionDetail.acceptanceAnnex]

          {
            // 处理产权人身份证图片
            const userIdCards = []
            if (that.installationDetail.userIdCardFront) {
              userIdCards.push(that.installationDetail.userIdCardFront)
            }
            if (that.installationDetail.userIdCardOpposite) {
              userIdCards.push(that.installationDetail.userIdCardOpposite)
            }

            if (userIdCards.length > 0) {
              this.$set(that.installationDetail, 'userIdCards', userIdCards.join(','))
            }

            // 处理被委托人身份证图片
            const reportUserIdCards = []
            if (that.installationDetail.reportUserIdCardFront) {
              reportUserIdCards.push(that.installationDetail.reportUserIdCardFront)
            }
            if (that.installationDetail.reportUserIdCardOpposite) {
              reportUserIdCards.push(that.installationDetail.reportUserIdCardOpposite)
            }

            if (reportUserIdCards.length > 0) {
              this.$set(that.installationDetail, 'reportUserIdCards', reportUserIdCards.join(','))
              this.$set(that.installationDetail, 'whetherEntrust', 1)
            } else {
              this.$set(that.installationDetail, 'whetherEntrust', 0)
            }
          }
        }
      })
    },
    init(row, bool) {
      this.collKey = -1
      this.title = this.$t('详情')
      this.visible = true
      this.bool = bool
      if (row.id) {
        this.getNodeDetail(row)
      }
    },
    close() {
      this.$emit('close')
      this.visible = false
    },
    handleCancel() {
      this.close()
    },
    getuserTypeList() {
      this.userTypeList = []
      getAction(this.url.meterUserType).then(res => {
        if (res.success) {
          this.userTypeList = res.result.records
        }
      })
    },
    queryUserTypeList() {
      //表类型请求
      let that = this
      getAction(that.url.meterTypeList).then(res => {
        if (res.success) {
          that.meterTypeList = res.result.records
        }
      })
    },
    queryUserCaliberList() {
      //表口径请求
      getAction(this.url.userCaliberList).then(res => {
        if (res.success) {
          this.userCaliberList = res.result.records
        }
      })
    },
    getmtCode(val) {
      return this.meterTypeList.find(m => m.id == val) && this.meterTypeList.find(m => m.id == val).mtName
    },
    getmtCaliber(val) {
      if (val) {
        return 'DN' + val
      }
    },
    getmtIotType(val) {
      let list = ['电信OC', '电信AEP', '移动', '联通']
      return list[++val]
    },
    getuserTypeCode(val) {
      return this.userTypeList.find(u => u.id == val) && this.userTypeList.find(u => u.id == val).utName
    },
  },
}
</script>
<style lang="less" scoped>
// .ant-divider-horizontal.ant-divider-with-text-left::before,
// .ant-divider-horizontal.ant-divider-with-text-left::after{
//   border-width: 2px;
//   border-color: #999;
// }
/deep/.ant-collapse {
  background-color: #fff;
}
/deep/.detail-list .content {
  line-height: normal;
}
/deep/.ant-form-item-label > label {
  color: #999;
}
.form-contain {
  height: 100% !important;
}
</style>
